import { useTranslation } from 'react-i18next'

import { Box, Button } from '@mui/material'

import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import DownloadIcon from '@mui/icons-material/Download'

import errorHandlerHook from '@hooks/useErrorHandler'
import responsiveHook from '@hooks/useResponsive'

import { TLGTypography } from '@components/TLGTypography'

import DownloadsUtils from '@utils/downloads'

import {
  buttonSx,
  buttonWrapperSx,
  checkIconSx,
  checkIconWrapperSx,
  registeredLeadFeedbackWrapperSx,
  textSx,
  textWrapperSx,
} from './styles'

const RegisteredLeadFeedback = () => {
  const { t } = useTranslation()

  const { isMobile } = responsiveHook.useResponsive()

  const { handleError } = errorHandlerHook.useErrorHandler()

  const handleOnDownloadButtonClick = () => {
    try {
      DownloadsUtils.downloadFromUrl({
        url: 'https://assets.technologymatch.com/public/leadmagnets/it-vendor-scorecard.pdf',
        fileName: 'IT Vendor Scorecard.pdf',
      })
    } catch (err) {
      handleError({ exception: err })
    }
  }

  return (
    <Box sx={registeredLeadFeedbackWrapperSx}>
      <Box sx={checkIconWrapperSx}>
        <CheckCircleIcon sx={checkIconSx} />
      </Box>
      <Box sx={textWrapperSx}>
        <TLGTypography
          responsiveVariant={{
            xs: 'h5',
            md: 'h4',
          }}
          sx={textSx}
        >
          {t('Thanks For Your Details')}
        </TLGTypography>

        <TLGTypography
          sx={textSx}
          responsiveVariant={{
            xs: 'subtitle1',
            md: 'h6',
          }}
        >
          {t(
            'Boom! Your Tech Vendor Scorecard is primed and ready. Dive in and dominate your vendor discovery.'
          )}
        </TLGTypography>

        <Box sx={buttonWrapperSx}>
          <Button
            data-testid="download-scorecard"
            variant="contained"
            size={isMobile ? 'small' : 'large'}
            sx={buttonSx}
            onClick={handleOnDownloadButtonClick}
            endIcon={<DownloadIcon />}
            color="secondary"
          >
            {t('Download Scorecard Now')}
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export { RegisteredLeadFeedback }
